"use client";

import React from "react";
import { EcommerceProductsProvider, useEcommerceProducts, AddToCartButton } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Badge } from "@/components/ui/badge";
function ProductsGridConsumer() {
  const {
    products,
    loading,
    error
  } = useEcommerceProducts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
        {[...Array(6)].map((_, i) => <div key={i} data-index={i} className="flex flex-col gap-4">
            <div className="aspect-video w-full animate-pulse rounded-lg bg-muted" />
            <div className="h-6 w-3/4 animate-pulse rounded bg-muted" />
            <div className="h-4 w-1/4 animate-pulse rounded bg-muted" />
            <div className="h-10 w-32 animate-pulse rounded bg-muted" />
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="flex min-h-[400px] items-center justify-center rounded-lg border border-dashed border-border bg-muted/30 p-8 text-center">
        <p className="text-muted-foreground">
          Failed to load products. Please try again later.
        </p>
      </div>;
  }
  if (products.length === 0) {
    return <div className="flex min-h-[400px] items-center justify-center rounded-lg border border-dashed border-border bg-muted/30 p-8 text-center">
        <p className="text-muted-foreground">No products found.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-x-8 gap-y-12 md:grid-cols-2 lg:grid-cols-3">
      {products.map((product, i) => <div key={product.id} data-index={i} className="group flex flex-col">
          <Link to={product.link} className="relative block overflow-hidden rounded-lg">
            {product.discounted_price && <Badge className="absolute right-3 top-3 z-10 border-none bg-[#4527A4] px-3 py-1 text-xs font-bold uppercase tracking-wider text-white hover:bg-[#4527A4]/90">
                Sale
              </Badge>}
            <AspectRatio ratio={16 / 9}>
              {product.featured_image_url ? <img src={product.featured_image_url} alt={product.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" /> : <div className="flex h-full w-full items-center justify-center bg-muted">
                  <span className="text-muted-foreground">No image</span>
                </div>}
            </AspectRatio>
          </Link>

          <div className="mt-5 flex flex-grow flex-col">
            <Link to={product.link}>
              <h3 className="font-default text-xl font-semibold leading-tight text-foreground transition-colors hover:text-primary">
                {product.title}
              </h3>
            </Link>

            <div className="mb-5 mt-3 flex items-baseline gap-2">
              {product.discounted_price ? <>
                  <span className="text-sm font-medium text-slate-500 line-through">
                    R{product.price.toFixed(2)}
                  </span>
                  <span className="text-lg font-bold text-foreground underline decoration-foreground underline-offset-4">
                    R{product.discounted_price.toFixed(2)}
                  </span>
                </> : <span className="text-lg font-bold text-foreground">
                  R{product.price.toFixed(2)}
                </span>}
            </div>

            <div className="mt-auto">
              <AddToCartButton productId={product.id} variant="default" className="w-full" buttonClassName="w-fit bg-[#4527A4] text-white hover:bg-[#4527A4]/90 px-6 py-2 rounded-md font-medium transition-colors" text="Add to cart" showQuantity={false} />
            </div>
          </div>
        </div>)}
    </div>;
}
export default function ProductListingGrid() {
  return <section id="productlistinggrid" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <EcommerceProductsProvider wp_query={{
        per_page: 50,
        order: "desc",
        orderby: "date"
      }}>
          <ProductsGridConsumer />
        </EcommerceProductsProvider>
      </div>
    </section>;
}